import { render, staticRenderFns } from "./RaceCourse.vue?vue&type=template&id=4673a981&scoped=true"
import script from "./RaceCourse.vue?vue&type=script&lang=js"
export * from "./RaceCourse.vue?vue&type=script&lang=js"
import style0 from "./RaceCourse.vue?vue&type=style&index=0&id=4673a981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673a981",
  null
  
)

export default component.exports